var map = {
	"./dark/status/20weight/01set.svg": "QFAZ",
	"./light/status/20weight/01set.svg": "x4bW"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "sAvC";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme ^\.\/.*\/status\/20weight\/01set\.svg$
// module id = sAvC
// module chunks = 0